export default __webpack_public_path__ + "static/media/banner_background.089672df.svg";